// -*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"
// eslint-disable-next-line
import clsx from "clsx"

// ROUTER
// eslint-disable-next-line
import { Link, Redirect } from "react-router-dom"

// MUI
// eslint-disable-next-line
import { makeStyles, withStyles } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import Typography from "@material-ui/core/Typography"
// eslint-disable-next-line
import Favorite from '@material-ui/icons/Favorite';
// eslint-disable-next-line
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';
import UncheckedCircle from '@material-ui/icons/RadioButtonUnchecked';
//import CheckedCircle from '@material-ui/icons/CheckCircleOutline';
import CheckedCircle from "@material-ui/icons/CheckCircle";
import Checkbox from "@material-ui/core/Checkbox"
// eslint-disable-next-line
import HelpIcon from "@material-ui/icons/HelpOutline"
import grey from "@material-ui/core/colors/grey"
import Paper from "@material-ui/core/Paper"
import Fab from "@material-ui/core/Fab"
import DownIcon from "@material-ui/icons/KeyboardArrowDown"
import UpIcon from "@material-ui/icons/KeyboardArrowUp"

// LogRocket
// import LogRocket from 'logrocket'



// BL
import { 
    getUserFromData,
    getContactsFromData,
    getIssuesFromData,
    getStatementsFromData,
    // new-arch
    readUserData,
    getContactsFromUserData,
    getIssuesFromUserData,
    getStatementsFromUserData,
    getDrives,
    initDrives,
    manageDrives,
    handleDriveChange,
} from "../../bl/A/bl"

import {
    parseUrl,
    distinct,
    groupBy,
    deepCopy,
    jsonPointerHas
} from "../Utils"


// UTILS
import * as _ from "lodash"

// FLASH
import FlashMessage from "./../FlashMessage.js"
import FlashSplash from "./../FlashSplash.js"
import FlashTopBar from "../Flash/FlashTopBar.js"
// import FlashHeader from "../Flash/FlashHeader.js"
// eslint-disable-next-line
import FlashSubHeader from "../Flash/FlashSubHeader.js"
// import FlashBottomBar from "../Flash/FlashBottomBar.js"
import FlashBottomPad from "../Flash/FlashBottomPad.js"

// GL
import gl from "../../gl.js"

// LOGGING SETUP
import appConfig from "./../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<Contacts>")
//LogRocket.init('sbqpcc/flashdev')


const styles = theme => ({

    //
    // GLOBAL STYLES START
    //

    checkedCircle: {
        ...theme.css.checkedCircle
    },

    uncheckedCircle: {
        ...theme.css.uncheckedCircle
    },
    

    //
    // GLOBAL STYLES END
    //

    contactList: {
        margin: 0,
        marginTop: 0,
        // tab from the left
        padding: "0px",
        // inside the container
        width: "100%",
    },

    //
    // new stuff
    //
    mainDiv: {
        // mobile
        marginTop: 0,
        marginBottom: 0,
        marginLeft: "auto",
        marginRight: "auto",
        padding: 0,
        paddingTop: 90,

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            paddingTop: 100,
	    maxWidth: 600,
            // marginBottom: 120,
        },

        color: theme.palette.test.mainFG,
        background: theme.palette.test.mainBG,
    },

    separatorDiv: {
        ...theme.css.separatorDiv,

        margin: 0 ,
        marginBottom: 0,
        borderRadius: 0,

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            width: theme.css.separatorDiv.desktop.width,
            height: theme.css.separatorDiv.desktop.height,
            marginTop: theme.css.separatorDiv.desktop.marginTop, // separate sections
            marginLeft: theme.css.separatorDiv.desktop.marginLeft,
            // borderTopLeftRadius: 6,
            // borderTopRightRadius: 6,
        },
        
    },

    text_disabled: {
        color: "#8c8c8c"
    },

    paperRoot: {
        // mobile
        margin: 0,
        maxWidth: "100%",
        padding: 10,
        paddingTop: 10,
        paddingBottom: 10,
        // maxHeight: 56,
        overflow: "hidden",
        cursor: "pointer",
        userSelect: "none",
        backgroundColor: "#FFFFFF",

        //backgroundColor: "#80808036",

        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            marginBottom: 0,
            borderBottom: "1px solid",
            borderBottomColor: grey[200],
	    borderRadius: 0,
        },

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            marginTop: 15,
            borderRadius: 6,
        },
        
    },


    paperRoot_disabled: {
        // mobile
        margin: 0,
        maxWidth: "100%",
        padding: 10,
        paddingTop: 10,
        paddingBottom: 10,
        // maxHeight: 56,
        overflow: "hidden",
        cursor: "pointer",
        userSelect: "none",
        // backgroundColor: "#FFFFFF",
        // backgroundColor: "#e2e2e2",
        // backgroundColor: "#e2e2e25c",
        backgroundColor: "#f3f3f3",
        
        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            marginBottom: 0,
            borderBottom: "1px solid",
            borderBottomColor: grey[200],
	    borderRadius: 0,
        },

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            marginTop: 15,
            borderRadius: 6,
        },
        
    },
    

    //
    // Animation
    //
    logoutDiv: {
//        position: "fixed",
//        top: 0,
//        left: 0,
//        height: "100%",
//        width: "100%",
//        display: "flex",
//        alignItems: "center", // vertical center
//        justifyContent: "center", // horizontal center
    },

    "@keyframes logoutAnimation":  {
        "0%": {
            opacity: 1,
//            fontSize: 12,
//            height: 200,
//            width: 200,
        },

        // fade in so that icon does not "blink"
        "10%": {
            opacity: 0.5,
//            fontSize: 12,
//            height: 200,
//            width: 200,
        },
       
        "100%": {
            opacity: 0,
            fontSize: 20,
            height: 400,
            width: 400,
        },

    },

    //
    // desktop
    //
    "@keyframes splashAnimation":  {
        "0%": {
            backgroundColor: theme.palette.primary.main,
        },
        
        "100%": {
            backgroundColor: theme.palette.primary.main,
        },
    },

    headerDiv: {
        //
        // mobile
        //
        marginTop: 0,
        marginBottom: 10,
        marginLeft: 20,
        marginRight: 20,

        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            marginLeft: 0,
            marginRight: 0,
        }
    },
    headerText: {
        fontSize: 30,
        fontWeight: 700,
        lineHeight: 1.1,
        color: grey[800],
    },


    subheaderText: {
        fontSize: "1.25rem",
        fontWeight: 300,
        color: grey[800],
//        marginBottom: 5,
    },



    // SCROLL FAB
    fab: {
        position: "fixed",
        //        bottom: theme.spacing(12),
                bottom: theme.spacing(2),

        //        right: theme.spacing(1),
        //        left: "45%", // middle

        left: "83%", // middle

        zIndex: 500,
        
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            left: "75%",
        },

    },
    
    fabGreen: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.custom.scrollDark,
        '&:hover': {
            backgroundColor: theme.palette.custom.scrollLight,
        },
    }
    
})

class Contacts extends Component {
    constructor(props) {
        super(props)
        log.debug("constructor()")

        const {history, location, match} = this.props
        log.debug("constructor(): history =", history)
        log.debug("constructor(): location =", location)
        log.debug("constructor(): match =", match)

        const initState =  {
            //fakeDriveSlugs: ["ca-sd13-alpha-drive-dev2", "ca-sd13-alpha-drive-dev"],
            fakeDriveSlugs: ["ca-sd13-alpha-drive-dev2"],
            scrollerDirection: "down",
            fakeControlled: false,
        }

        const urlObj = parseUrl(location, match)

        log.debug("constructor(): urlObj =", urlObj)
        if(urlObj.drive) {
            log.debug("constructor(): YES, we have drive")
        } else {
            log.debug("constructor(): no, we don't have drive")
        }

        if(urlObj.drive) {
            initState.drive = urlObj.drive
            localStorage.setItem("drive", JSON.stringify(initState.drive))
        } else {
            localStorage.removeItem("drive")
        }


        const isFirstLogon = localStorage.getItem("isFirstLogon")
        if(isFirstLogon) {
            localStorage.setItem("isFirstLogon", false)
        }

        initState.isFirstLogon = isFirstLogon
        
        this.state = initState
        
    }


    handleScroll = (event) => {
        log.trace("<contacts>: handleScroll(): event = ", event)

        if(!this.state.scrollerDirection) {
            this.setState({scrollerDirection: "down"})
            return
        }

        const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight,  html.scrollHeight, html.offsetHeight);
        const windowBottom = windowHeight + window.pageYOffset;

        log.trace("handleScroll(): window.pageYOffset =", window.pageYOffset)

        if (windowBottom >= (docHeight - 1)) {
            this.setState({scrollerDirection: "up"})
        } else if(window.pageYOffset === 0) {
            this.setState({scrollerDirection: "down"})
        }
    }

    scrollToBottom = () => {
        log.debug("<Issues>: scrollToBottom(): this.contentDivEl = ", this.contentDivEl)
        log.debug("<Issues>: scrollToBottom(): this.tailDivEl = ", this.tailDivEl)

        if(this.tailDivEl) {
            this.tailDivEl.scrollIntoView({
                behavior: "smooth",
                block: "start",
            })
        }
    }

    scrollToTop = () => {
        log.debug("<Issues>: scrollToBottom(): this.headDivEl = ", this.headDivEl)
        log.debug("<Issues>: scrollToBottom(): this.tailDivEl = ", this.tailDivEl)
        
        if(this.headDivEl) {
            this.headDivEl.scrollIntoView({
                behavior: "smooth",
                block: "start",
            })
        }
    }

    handleNext = (onError) => {
        log.trace("handleNext()")
        // get all the checked contacts
        for(let i=0; i < this.state.gl.contacts.length; i++) {
            let contact = this.state.gl.contacts[i]
            contact.isChecked = true
            log.debug("handleNext(): contact = ", contact)
        }
        
        let checkedContacts = _.filter(this.state.gl.contacts, ["isChecked", true])
        log.debug("handleNext(): checkedContacts = ", checkedContacts)

        let isNextHelp = checkedContacts && checkedContacts.length > 0  ? false : true
        log.trace("handleNext(): isNextHelp = ", isNextHelp)
        if(isNextHelp) {
            this.setState({ isHelpVisible: isNextHelp })
            return
        }

        let localGL = this.state.gl
        localStorage.setItem("gl", JSON.stringify(localGL))
        log.debug("handleNext(): saved localGL")
        
        //localStorage.removeItem("isFirstLogon")
        this.setState({redirectToNext: true})
    }

    handleError = (text) => {
        log.trace("handleError(): text = ", text)
        this.setState({
            isHelpVisible: true,
            helpText: text
        })
    }


    handleHelpDone = () => {
        this.setState({isHelpVisible: false})
    }


    handleCheckboxChange_new = uuid => event => {
    }

    handleCheckboxChange= uuid => event => {
        log.trace(`handleCheckboxChange(): uuid = ${uuid}, event = ${event}`)
        let contact = (_.filter(this.state.gl.contacts, ["uuid", uuid]))[0]

        log.debug("handleCheckboxChange(): contact found = ", contact)
        if(!contact.isChecked) {
            contact.isChecked = true
        } else if(contact.isChecked === true) {
            contact.isChecked = false
        } else if(contact.isChecked === false) {
            contact.isChecked = false
        }

        log.trace("handleCheckboxChange(): contact.isChecked = ", contact.isChecked)
        
        this.setState({gl: this.state.gl})

        log.trace("handleCheckboxChange(): contact.isChecked = ", contact.isChecked)

    }

    /*
    handleDriveError = error => {
        if(error.data && error.data.user === null) {
            // we connected to vapor but user is not found
            log.error("handleDataError(): ERROR: user not found, redirecting to Register")
            this.setState({...this.state, redirectToRegister: true })
            return
        } else {
            log.error("handleDataError(): ERROR: error =", error)
            // we connected to vapor but user is not found
            log.error("handleDataError(): ERROR: could not connect to server, redirecting to Register")
            this.setState({...this.state, redirectToRegister: true })
            return
        }
    }
    */

    

    // this is called after the data is received
    handleDataResult = result => {
        log.debug("handleDataResult(): result =", result)

        // DEMO1, we should not have to set attributes
        // to savedUser local values here if it's a "real"
        // account in the future, after registration
        // is finished
        // for now, get the saved stuff from the drive

        let savedData = JSON.parse(localStorage.getItem("user"))
        let resultData = result.data.user
        let user = getUserFromData(result.data.user)

        
        // merge all user attributes for demo1
        user = {
            ...user,
            name: savedData.name,
            email: savedData.email,
            loginLevel: resultData.loginLevel,
            address: {
                street: savedData.address.street,
                zipPlus4: savedData.address.zipPlus4,
            },
            appIsSignedIn: savedData.appIsSignedIn,
            appIsSignedInType: savedData.appIsSignedInType,
            city: resultData.city,
            county: resultData.county,
            state: resultData.state,
            federal: resultData.federal
        }

        log.trace("handleDataResult(): after demo1 merging, user =", user)

        gl.user = user
        gl.contacts = getContactsFromData(resultData)
        gl.issues = getIssuesFromData(resultData)
        gl.statements = getStatementsFromData(resultData)
        log.trace("handleDataResult(): AFTER: gl = ", gl)

        // add your reason items
        _.map(gl.issues, issue => {
            log.trace("handleDataResult(): issue =", issue)
            log.trace("handleDataResult(): statement =", gl.statements[10])
            const yourReason = {
                check: false,
                checkMax: 4,
                issue: issue,
                opinion: "expert",
                priority: 0, // replaced by rank
                procon: "pro",
                rate: 0,
                state: "open",
                statementsTotal: null,
                timestamp: null,
                // txt: issue.uuid + "-text",
                txt: "",
                user: gl.user,
                uuid: issue.uuid + "-yourreason",
                isYourReason: true,
            }

            log.trace("handleDataResult(): yourReason =", yourReason)
            gl.statements.push(yourReason)
        })
        
        this.setState({
            user: user,
            gl: gl,
        })
    }

    handleDataError = error => {
        if(error.data && error.data.user === null) {
            // we connected to vapor but user is not found
            log.error("handleDataError(): ERROR: user not found, redirecting to Register")
            this.setState({...this.state, redirectToRegister: true })
            return
        } else {
            log.error("handleDataError(): ERROR: error =", error)
            // we connected to vapor but user is not found
            log.error("handleDataError(): ERROR: could not connect to server, redirecting to Register")
            this.setState({...this.state, redirectToRegister: true })
            return
        }
    }

    componentWillUnmount  = () => {
        window.removeEventListener("scroll", this.handleScroll)
    }

    
    handleReadUserDataResult = (result) => {
        log.debug("handleReadUserDataResult(): result = ", result)
        const userData = result.data.user
        log.debug("handleReadUserDataResult(): userData = ", userData)

        gl.user = {
            ...userData,
            geo: {
                ...userData.geo,
                address: {
                    ...userData.geo.address,
                    zipPlus4: `${userData.geo.address.zip.code}-${userData.geo.address.zip.plus4}`
                }
            }
        }

        log.debug("handleReadUserDataResult(): gl.user = ", gl.user)
        
        gl.contacts = getContactsFromUserData(userData)
        log.debug("handleReadUserDataResult(): gl.contacts = ", gl.contacts)
        gl.issues = getIssuesFromUserData(userData)
        log.debug("handleReadUserDataResult(): gl.issues = ", gl.issues)
        gl.statements = getStatementsFromUserData(userData)
        log.debug("handleReadUserDataResult(): gl.statements = ", gl.statements)
        log.debug("handleReadUserDataResult(): AFTER: gl = ", gl)

        manageDrives(this)(gl.statements)
        
        const debugGroup = groupBy(gl.statements, statement => (`{driveSlug: ${statement.drive.slug}, issueSlug: ${statement.issue.slug}, statementSlug: ${statement.slug}}`))

        log.debug("handleReadUserDataResult(): debugGroup = ", debugGroup)

        log.debug("handleReadUserDataResult(): settings state")
        
        this.setState({
            user: gl.user,
            gl: gl
        })
    }


    handleReadUserDataError = (error) => {
        log.debug("handleReadUserDataError(): error = ", error)
        // redirect to register
        this.setState({redirectToRegister: true })  
    }


    handleBarChange = (change) => (event) => {
        log.debug("handleBarChange(): change = ", change)
        log.debug("handleBarChange(): event = ", event)
        switch(change.widget) {
        case "drive":
            handleDriveChange(this)(change)
            break
        default:
        }
    }

    componentDidMount = () => {
        window.addEventListener("scroll", this.handleScroll)
        this.scrollToTop()

        const savedUser = JSON.parse(localStorage.getItem("user"))

        if(!savedUser) {
            // this.setState({ redirectToProfile: true })
            this.setState({...this.state, redirectToRegister: true })            
            return
        }

        log.debug("componentDidMount(): savedUser = ", savedUser)

        const user = {
            email: savedUser.email
        }


        this.setState({
            redirectToNext: false,
            redirectToRegister: false,
            isHelpVisible: false,
            scrollerDirection: "down",
            variation: {
                current: "A",
                A: "/contacts/a",
                B: "/contacts/b",
            },
            user: user,
            ...initDrives(this)
        })

	readUserData(user, {
	    onResult: this.handleReadUserDataResult,
	    onError: this.handleReadUserDataError
	})

    }

    componentDidUpdate = (prevProps) => {

        const {driveSlug: oldDriveSlug} = prevProps.match.params
        const {driveSlug: newDriveSlug} = this.props.match.params
        const { drives } = this.state

        log.trace("componentDidUpdate(): oldDriveSlug =", oldDriveSlug)
        log.trace("componentDidUpdate(): newDriveSlug =", newDriveSlug)
        
        if(oldDriveSlug !== newDriveSlug) {
            const newDrive = drives.find(drive => drive.slug === newDriveSlug)
            log.trace("componentDidUpdate(): this.state.drives =", this.state.drives)
            log.trace("componentDidUpdate(): newDrive =", newDrive)
            if(newDrive) {
                this.setState({drive: newDrive})
            }
        }
        
    }

    
    render() {
        const { classes, history } = this.props

        log.debug("render(): isFirstLogon =", this.state.isFirstLogon)

        // redirect

        if(!this.state.isFirstLogon) {
            history.push("/issues")
        }

        const { driveSlug } = this.props.match.params
        if(!driveSlug) {
            return(<Redirect push to={"/drives/all/contacts"}/>)
        }
        

        // redirects first
        if(this.state.redirectToRegister) {
            log.debug("componentDidMount(): redirecting to Register")

            const { driveSlug } = this.props.match.params
            if(driveSlug) {
                const newUrl = `/drives/${driveSlug}/register`
                return (<Redirect push to={newUrl}/>)
            }
            
            return <Redirect push to="/register"/>
        } else if(this.state.redirectToNext) {
            //NEXT: all of this - switch it to history push, otherwise it looks like things are getting confused
            let nextUrl = "/issues"
            if(this.state.drive) {
                nextUrl = "/drives/" + this.state.drive.slug + nextUrl
            }

            log.debug("render(): nextUrl =", nextUrl)
            return <Redirect push to={nextUrl}/>
        }

        log.trace("render(): this.state = ", this.state)
        
        if(!this.state) {
            log.debug("render(): no state = ", this.state)
        }

        if(!this.state.gl) {
            log.debug("render(): no state.gl = ", this.state)
            log.debug("render(): no so gracefully loading...")
            // return (<div></div>)

            return (<React.Fragment>
                      <div ref={(el) => { this.headDivEl = el; }} ></div>
                      <Typography variant="h6">
                        Loading...
                      </Typography>
                    </React.Fragment>)

//            return(
//                <FlashSplash isVisible={true} variant="nocontacts" onDone={()=>{}}/>
//            )
        }

        // see if we need to go directly to the issues




        
        let { statements, contacts, user } = this.state.gl
        // process for all drive
        log.debug("render(): user = ", user)
        log.debug("render(): user.geo.address.city.name = ", user)
        log.debug("render(): user.geo.address.city.name = ", user)


        
        if(jsonPointerHas(this.state, "/drive/slug")) {
            //           && this.state.drive.slug !== "all") {



            const doIncludeForAll = (contact) => {

                const driveStatements = statements

                const driveLevels = distinct(driveStatements, statement => `${statement.issue.level}`)
                if(driveLevels.includes(contact.level)) {
                    // should be included
                    return true
                } else {
                    // should not be included
                    return false
                }
            }

            const doIncludeForMember = (contact) => {

                const driveStatements = statements
                      .filter(statement => statement.drive
                              && statement.drive.slug === this.state.drive.slug)

                const driveLevels = distinct(driveStatements, statement => `${statement.issue.level}`)
                if(driveLevels.includes(contact.level)) {
                    // should be included
                    if(contact.position.name === "stateSenateMember") {
                        return true
                    } else if (contact.position.name === "congressMember") {
                        console.log("render(): doIncludeForMember(): contact = ", contact)
                        return true
                    } else {
                        return false
                    }
                } else {
                    // should not be included
                    return false
                }
            }

//            const driveStatements = statements
//                  .filter(statement => statement.drive
//                          && statement.drive.slug === this.state.drive.slug)
//            log.debug("render(): driveStatements = ", driveStatements)

            const doInclude = this.state.drive.slug === "all" ? doIncludeForAll : doIncludeForMember
            
            contacts = contacts.map(contact => {
                if(doInclude(contact)) {
                    return {
                        ...contact,
                        isDisabled: false
                    }
                } else {
                    return {
                        ...contact,
                        //isDisabled: true
                        isDisabled: false
                    }
                }
            })
            //const driveIssues = issues.filter(issue => {
            //return driveStatements.find(statement => statement.issue.slug === issue.slug) ? true : false
            //            })
            //            log.debug("render(): driveIssues = ", driveIssues)
            //            items = driveIssues
        }

        

        // NEXT: first get the statements just for this drive and then derive the contacts, probably after we do the state levels
        
        const items = contacts
        //const user = this.state.gl.user

        // TODO: this should probably in the
        // original data pool, but having it here does not
        // hurt for now, since that's the function of this page
        let positions = {
            president: {seniority: 1040, level: "federal"},
            vicePresident: {seniority: 1030, level: "federal"},
            senateMember: {seniority: 1020, level: "federal"},
            congressMember: {seniority: 1010, level: "federal"},

            governor: {seniority: 2040, level: "state"},
            lieutenantGovernor: {seniority: 2030, level: "state"},
            stateSenateMember: {seniority: 2020, level: "state"},
            assemblyMember: {seniority: 2010, level: "state"},
            
            countyPresident: {seniority: 3020, level: "county"},
            countySupervisor: {seniority: 3010, level: "county"},
            
            mayor: {seniority: 4050, level: "city"},
            viceMayor: {seniority: 4040, level: "city"},
            mayorProTem: {seniority: 4030, level: "city"},
            cityManager: {seniority: 4020, level: "city"},
            councilMember: {seniority: 4010, level: "city"},
        }

        // TODO: this is iffy since we're modifying the contacts itself,
        // but works in JS so far
        items.forEach(contact => {
            if(positions[contact.position.name]) {
                contact.seniority = positions[contact.position.name].seniority
            }
        })

        log.debug("render(): items with seniority =",items)
        
        items.sort((a,b) => {
            // return a.seniority - b.seniority // bottom-up
            return b.seniority - a.seniority // top-bottom
        })
        
        log.debug("render(): user =",user)

        // some precounts of city items
        let cityItems = _.filter(items, ["level", "city"])
        // let cityIssueCount
        // we can take the first contact in that section
        // and grab the count there, each contact has
        // the number if "their" issues recalculated
        // and it should be equal for all contacts in that section
        if(cityItems && cityItems[0] && cityItems[0].appIssueCount) {
            // cityIssueCount = cityItems[0].appIssueCount
        } else {
            // cityIssueCount = 0
        }
        
        let countyItems = _.filter(items, ["level", "county"])
        let stateItems = _.filter(items, ["level", "state"])
        log.debug("render(): stateItems =", stateItems)
        
        let federalItems = _.filter(items, ["level", "federal"])
        
        log.debug("render(): cityItems =", cityItems)

        let repNum = cityItems.length + countyItems.length + stateItems.length + federalItems.length


        /*
        let welcomeText1 = "Welcome " + this.state.user.name.split(" ")[0] + "; "

        if(!this.state.user.FirstLogin) {
            // welcomeText1 = "Welcome back " + this.state.user.name.split(" ")[0] + "; "
            const name = "Dmitri"
            welcomeText1 = "Welcome back " + name + "; "
        }
        */


        let welcomeText1
        if(this.state.isFirstLogon) {
            welcomeText1 = "Welcome " + this.state.user.name.split(" ")[0] + ""
        } else {
            welcomeText1 = "Welcome back " + this.state.user.name.split(" ")[0] + ""
        }


        let welcomeText2 = "these"
        let welcomeText3 = " are your (" + repNum + ") representatives"


        //        let selectText = "Select who you would like to address"
        // let selectText ="You can address those who have active buttons"
        //let selectText ="Address those with active buttons, more are being added"
        //let selectText ="Tell them your concerns about today’s Issues"
        const selectText = ""


        let separatorText = []

        separatorText.push("Federal")        
        
        // ND Special
        if(this.state.user.geo.address.zipPlus4 === "12345-0000") {
            log.debug("render(): I'm an ND case!!")
            welcomeText1 = "Welcome " + this.state.user.name.split(" ")[0]
            welcomeText2 = ""
            welcomeText3 = ""
            selectText = "Select who you want to address"
            separatorText.pop(0)
            separatorText.push("Officials")
        }

        //
        // Drive processing
        //

        /*
        log.debug("render(): this.state.drive =", this.state.drive)
        if(jsonPointerHas(this, "/state/fakeDriveSlugs")
           && jsonPointerHas(this, "/state/drive/slug")
           && this.state.fakeDriveSlugs.includes(this.state.drive.slug)) {
            log.debug("render(): YES include")
        } else {
            log.debug("render(): NO include")
        }
        */
        
        /*
        federalItems = federalItems.map(value => {
            if(this.state.drive && this.state.fakeDriveSlugs.includes(this.state.drive.slug)) {
                value.isDisabled = true
            } else {
                value.isDisabled = false
            }
            return value
        })

        stateItems = stateItems.map(value => {
            if(this.state.drive && this.state.fakeDriveSlugs.includes(this.state.drive.slug)
               && value.person.name === "Josh Becker"
              ) {
                value.isDisabled = false // just for becker
            } else if(this.state.drive && this.state.fakeDriveSlugs.includes(this.state.drive.slug)) {
                value.isDisabled = true // for all the others in that drive
            } else {
                value.isDisabled = false // default
            }
            return value
        })

        countyItems = countyItems.map(value => {
            if(this.state.drive && this.state.fakeDriveSlugs.includes(this.state.drive.slug)) {
                value.isDisabled = true
            } else {
                value.isDisabled = false
            }
            return value
        })

        cityItems = cityItems.map(value => {
            if(this.state.drive && this.state.fakeDriveSlugs.includes(this.state.drive.slug)) {
                value.isDisabled = true
            } else {
                value.isDisabled = false
            }
            return value
        })
        */
        
	return (
            <React.Fragment>
	      <CssBaseline/>

              <div ref={(el) => { this.headDivEl = el; }} ></div>

              {
                  //
                  // ANIMATION
                  //
              }

              <div className={classes.spashDiv}></div>

              <FlashSplash isVisible={true} variant="nocontacts" onDone={()=>{}}/>

              <FlashMessage isVisible={this.state.isHelpVisible} variant="nocontacts" onDone={this.handleHelpDone}/>
              

               <FlashTopBar
                 text="Your Representatives"
                 variation={this.state.variation}
                 drives={this.state.drives}
                 history={this.props.history}
                 match={this.props.match}
                 onChange={this.handleBarChange}
               />

              <div className={classes.mainDiv}>
                {/* <FlashHeader text={welcomeText}/> */}

                <div className={classes.headerDiv}>
                  <Typography style={{fontSize: 25}} className={classes.headerText} variant="h6" display="inline">
                    {welcomeText1}. Here are your representatives.
                  </Typography>

                  <div/>
                  <Typography style={{fontSize: 25}} className={classes.headerText} variant="h6" display="inline">
                    Click "Next" to share your thoughts about issues
                  </Typography>

                  
                  <Typography style={{fontSize: 25}} className={classes.headerText} variant="h6">
                    and we'll make sure they hear you.
                  </Typography>
                  
                  {/*
..AND we'll connect you
                  <Typography className={classes.headerText} variant="h6" display="inline" style={{fontStyle: "italic"}}>
                    {welcomeText2}
                  </Typography>
                  <Typography className={classes.headerText} variant="h6" display="inline">
                    {welcomeText3}
                  </Typography>
                   */}
                </div>
                

                <Typography className={classes.subheaderText} variant="h6" style={{marginLeft: 25, marginTop: 20, marginBottom: 10, marginRight: 25}}>
                  {selectText}
                </Typography>
                
                {/*
                <FlashSubHeader style={{marginBottom: 100}} text1={
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        width: 400,
                    }}>
                      <div style={{marginBottom: 5}}>
                        <Typography className={classes.subheaderText} variant="h6">
                          Select who needs to hear from you and we'll find the issues they cover
                        </Typography>
                      </div>
                      <div style={{}}>
                        <HelpIcon style={{fontSize: 30, color: grey[500], paddingTop: 0, marginLeft: 5,}}/>
                      </div>
                    </div>
                }>
                  <Typography className={classes.subheaderText} variant="h6" style={{fontSize: 18, marginLeft: 10 }}>
                    <div style={{display: "inline", fontWeight: 400}}>We'll find the issues they cover</div>
                  </Typography>
                </FlashSubHeader>
                 */}


                                
                {
                    //
                    // Federal
                    //
                }

                {federalItems.length ?
                 <div>
                   <div className={classes.separatorDiv}>
                     <Typography variant="subtitle1" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                       {separatorText[0]}
                       {/* Federal */}
                       {/* {user.federal.name} */}
                     </Typography>
                   </div>
                   <ul className={classes.contactList}>
                     {federalItems.map((value, index) => {
                         if(value.position.description !=="Vice President of the US")
                             return (
                                 <Paper className={clsx({
                                     [classes.paperRoot]: true,
                                     [classes.paperRoot_disabled]: value.isDisabled,
                                 })} key={index}>
                                   <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                                     <div>
                                       <Typography className={clsx({[classes.text_disabled]: value.isDisabled})} variant="subtitle2" style={{marginLeft: 20, fontSize: 17, fontWeight: "bold"}}>
                                         {value.position.description}
                                       </Typography>
                                       <Typography className={clsx({[classes.text_disabled]: value.isDisabled})} variant="body2" display="inline" style={{marginLeft: 20, fontSize: 16}}>
                                         {value.person.name}
                                       </Typography>
                                       <div/>
                                     </div>
                                     {/*
                                     {!value.isDisabled &&
                                      <Checkbox
                                        icon={<UncheckedCircle className={classes.uncheckedCircle}/>}
                                        checkedIcon={<CheckedCircle className={classes.checkedCircle}/>}
                                        checked={value.isChecked ? value.isChecked : false}
                                        onChange={this.handleCheckboxChange(value.uuid)}>
                                      </Checkbox>
                                     }
                                      */}
                                   </div>
                                 </Paper>
                             )
                         else
                             return (<div key="nothing"/>)
                     })}
                   </ul>
                 </div>
                 : null }


                {
                    //
                    // State
                    //
                }


                {stateItems.length ?
                 <div>
                   <div className={classes.separatorDiv}>
                     <Typography variant="subtitle1" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                       {/* State */}
                       {user.geo.address.state.name}
                     </Typography>
                   </div>
                   
                   <ul className={classes.contactList}>
                     {stateItems.map((value, index) => {
                         return (
                             <span key={`${index}-span`}>
                             <Paper className={clsx({
                                 [classes.paperRoot]: true,
                                 [classes.paperRoot_disabled]: value.isDisabled,
                             })} key={index}>
                               <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                                 <div>
                                   <Typography className={clsx({[classes.text_disabled]: value.isDisabled})} variant="body2" display="inline" style={{marginLeft: 20, fontSize: 16, fontWeight: "bold" }}>
                                     {value.position.description}
                                   </Typography>
                                   <Typography className={clsx({[classes.text_disabled]: value.isDisabled})} variant="subtitle2"style={{marginLeft: 20, fontSize: 17, fontWeight: "normal"}}>
                                     {value.person.name}
                                   </Typography>
                                   <div/>
                                   {/*
                                      <Typography variant="body2" display="inline" style={{marginLeft: 20, fontSize: 12}}>
                                      {value.districtDescription}
                                      </Typography>
                                    */}
                                 </div>
                                 {/*
                                 {!value.isDisabled &&
                                  <Checkbox
                                    icon={<UncheckedCircle className={classes.uncheckedCircle}/>}
                                    checkedIcon={<CheckedCircle className={classes.checkedCircle}/>}
                                    checked={value.isChecked ? value.isChecked : false}
                                    onChange={this.handleCheckboxChange(value.uuid)}
                                  >
                                  </Checkbox>
                                 }
                                  */}
                               </div>
                             </Paper>
                             </span>                             
                         )})}
                   </ul>
                 </div>
                 : null}

                {
                    //
                    // County
                    //
                }
                {countyItems.length ?
                 <div>
                <div className={classes.separatorDiv}>
                  <Typography variant="subtitle1" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                    {/*
                       County
                     */}
                    {user.geo.county.name}
                  </Typography>
                </div>
                <ul className={classes.contactList}>
                  {countyItems.map((value, index) =>  {
                      return (
                          <Paper className={clsx({
                              [classes.paperRoot]: true,
                              [classes.paperRoot_disabled]: value.isDisabled,
                          })} key={index}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                              <div>
                                <Typography className={clsx({[classes.text_disabled]: value.isDisabled})} variant="body2" display="inline" style={{marginLeft: 20, fontSize: 16, fontWeight: "bold"}}>
                                  {value.position.description}
                                </Typography>
                                <Typography className={clsx({[classes.text_disabled]: value.isDisabled})} variant="subtitle2"style={{marginLeft: 20, fontSize: 17, fontWeight: "normal"}}>
                                  {value.person.name}
                                </Typography>
                                <div/>
                                {/*
                                   <Typography variant="body2" display="inline" style={{marginLeft: 20, fontSize: 12}}>
                                   {value.districtName}
                                   </Typography>
                                 */}
                              </div>
                              {/*
                          {!value.isDisabled &&
                              <Checkbox
                                icon={<UncheckedCircle className={classes.uncheckedCircle}/>}
                                checkedIcon={<CheckedCircle className={classes.checkedCircle}/>}
                                checked={value.isChecked ? value.isChecked : false}
                                onChange={this.handleCheckboxChange(value.uuid)}
                              >
                           </Checkbox>
                          }
                               */}
                            </div>
                          </Paper>
                      )})}
                 </ul>
                 </div>
                 : null }

                {
                    //
                    // City
                    //
                }
                {cityItems.length ?
                 <div>
                <div className={classes.separatorDiv}>
                  <Typography variant="h6" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                    {user.geo.address.city.name}
                  </Typography>
                </div>
                <ul className={classes.contactList}>
                  {cityItems.map((value, index) => {
                      return (
                          <Paper className={clsx({
                              [classes.paperRoot]: true,
                              [classes.paperRoot_disabled]: value.isDisabled,
                          })} key={index}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                              <div>
                                <Typography className={clsx({[classes.text_disabled]: value.isDisabled})} variant="body2" display="inline" style={{marginLeft: 20, fontSize: 16, fontWeight: "bold"}}>
                                  {value.position.description}
                                </Typography>
                                <Typography className={clsx({[classes.text_disabled]: value.isDisabled})} variant="subtitle2"style={{marginLeft: 20, fontSize: 17, fontWeight: "normal" }}>
                                  {value.person.name}
                                </Typography>
                                <div/>
                              </div>
                              {/*
                          {!value.isDisabled &&
                              <Checkbox
                                icon={<UncheckedCircle className={classes.uncheckedCircle}/>}
                                checkedIcon={<CheckedCircle className={classes.checkedCircle}/>}
                                 checked={value.isChecked ? value.isChecked : false}
                                onChange={this.handleCheckboxChange(value.uuid)}>
                           </Checkbox>
                          }
                               */}
                            </div>
                          </Paper>
                      )})}
                 </ul>
                 </div>
                 : null }

                <div style={{paddingTop: 40, fontSize: 16}} className={classes.headerDiv}>
                  <Typography className={classes.headerText} variant="h6" display="inline">
                    See current issues
                  </Typography>
                </div>
                
            {/* or do this
                <div style={{marginTop: 25, marginBottom: 15, marginRight: 25, marginLeft: 25}}>
                  <Typography className={classes.subheaderText} variant="h6" display="inline">
                    Issues are gathered from the community at large
                </Typography>
                </div>
             */}
                
                 
              </div>
              
              {/*
              <FlashBottomBar
                nextButton={{
                    text: "NEXT",
                    link: "/issues",
                    onClick: this.handleNext,
                    onError: this.handleError,
                }}
              />
               */}

              { this.state.scrollerDirection && this.state.scrollerDirection === "down" &&
                <Fab aria-label="scroll"
                     className={clsx(classes.fab, classes.fabGreen)}
                     onClick={this.scrollToBottom}>
                  <DownIcon style={{fontSize: 50}}/>
                </Fab>
              }

              { this.state.scrollerDirection && this.state.scrollerDirection === "up" &&
                <Fab aria-label="scroll"
                     className={clsx(classes.fab, classes.fabGreen)}
                     onClick={this.scrollToTop}>
                  <UpIcon style={{fontSize: 50}}/>
                </Fab>
              }


              <FlashBottomPad
                nextButton={{
                    text: "NEXT",
                    link: "/issues",
                    onClick: this.handleNext,
                    onError: this.handleNextError,
                }}
              />

              <div ref={(el) => { this.tailDivEl = el; }} ></div>

            </React.Fragment>
	)
    }
}

Contacts.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles, { name: "Contacts" })(Contacts)

